export default __webpack_public_path__ + "a36d95ac21940ac3dd9305659b69df5a.png";